import * as Constants from '../../utilities/constants/Constants';
import { getCostCurrency } from '../../utilities/HelperFunctions/HelperFunctions';
import { tieleValue } from './Placebale';

export class Placing {
  constructor(placeable) {
    this.placeableId = placeable ? placeable.id : null;
    this.mediaId = placeable ? placeable.mediaId : null;
    this.imageSource = placeable ? placeable.imageSource : null;
    this.userPhotoType =
      placeable &&
      Object.prototype.hasOwnProperty.call(placeable, 'userPhotoType')
        ? placeable.userPhotoType
        : null;
    this.id = null;
    this.placeableType = placeable ? placeable.type : null;
    this.yOffset = 0;
    this.xOffset = 0;
    this.height = null;
    this.width = null;
    this.tiled = tieleValue(placeable);
    this.locked = false;
    this.flipX = false;
    this.storeId = null;
    this.zIndex = null;
    this.angle = 0;
    this.destroy = false;
    this.themeId = null;
    this.groupId = null;
    this.groupWidth = null;
    this.groupHeight = null;
    this.groupZIndex = 0;
    this.parentGroupId = null;
    this.planeConfig = null;
    this.clonable = false;
    this.opacity = null;
    this.count = 1;
    this.wallId = null;

    this.externalPlaceable = placeable ? placeable.externalPlaceable : false;

    this.placeable = placeable;
    this.isSvgRecolored = false;
    this.isRecoloredInThisSession = false;
    this.isDuplicate = false;
    this.wallIndex = 0;
  }
}

export const copyPlacing = (placing, placingJSON) => {
  placing.placeableId = placingJSON.placeable_id;
  placing.id = placingJSON.id;
  placing.placeableType = placingJSON.placeable_type;
  placing.yOffset = placingJSON.y_offset;
  placing.xOffset = placingJSON.x_offset;
  placing.height = placingJSON.height;
  placing.width = placingJSON.width;
  placing.tiled = placingJSON.tiled;
  placing.locked = placingJSON.locked;
  placing.flipX = placingJSON.flip_x;
  placing.storeId = placingJSON.store_id;
  placing.zIndex = placingJSON.zindex;
  placing.angle = placingJSON.angle;
  placing.externalPlaceable = placingJSON.external_placeable;
  placing.destroy = false;
  placing.themeId = placingJSON.theme_id;
  placing.groupId = placingJSON.group_id;
  placing.groupWidth = placingJSON.group_width;
  placing.groupHeight = placingJSON.group_height;
  placing.groupZIndex = placingJSON.group_z_index;
  placing.parentGroupId = placingJSON.parent_group_id;
  placing.planeConfig = placingJSON.plane_config;
  placing.clonable = placingJSON.clonable;
  placing.opacity = placingJSON.opacity;
  placing.count = placingJSON.count;
  placing.wallId = placingJSON.wall_id;
  placing.placeable = null;
};

export const copyPlaceable = (placing, placeable) => {
  placing.placeableId = placeable.id;
  placing.mediaId = placeable.mediaId ? placeable.mediaId : null;
  placing.imageSource = placeable.imageSource ? placeable.imageSource : null;
  placing.userPhotoType =
    placeable &&
    Object.prototype.hasOwnProperty.call(placeable, 'userPhotoType')
      ? placeable.userPhotoType
      : null;
  placing.placeableType = placeable ? placeable.type : null;
};

export const toPlacingJSON = placing => {
  const placingJSON = {
    placeable_id: placing.placeableId,
    id: placing.id,
    placeable_type: placing.placeableType,
    y_offset: placing.yOffset,
    x_offset: placing.xOffset,
    height: placing.height,
    width: placing.width,
    tiled: placing.tiled,
    locked: placing.locked,
    flip_x: placing.flipX,
    store_id: placing.storeId,
    zindex: placing.zIndex,
    angle: placing.angle,
    _destroy: placing.destroy,
    theme_id: placing.themeId,
    external_placeable: placing.externalPlaceable,
    group_id: placing.groupId,
    group_width: placing.groupWidth,
    group_height: placing.groupHeight,
    group_z_index: placing.groupZIndex,
    parent_group_id: placing.parentGroupId,
    plane_config: placing.planeConfig,
    clonable: placing.clonable,
    opacity: placing.opacity,
    count: placing.count,
    wall_id: placing.wallId
  };
  if (placing.placeableType === Constants.USER_PHOTO_TYPE) {
    placingJSON.media_id = placing.mediaId;
    placingJSON.image_source = placing.placeable.imageSource;
    placingJSON.user_photo_type = placing.placeable.userPhotoType;
    placingJSON.cost_value = placing.placeable.costValue;
    placingJSON.cost_currency = getCostCurrency(placing.placeable);
    if (placing.placeable.svgColors && placing.placeable.svgColors.length > 0) {
      placingJSON.svg_colors = placing.placeable.svgColors;
    } else {
      placingJSON.colors = placing.placeable.colors;
    }
  }
  return placingJSON;
};

export const toUserPlacingJSON = placing => {
  const jsonObj = {
    text_id: placing.placeableId,
    id: placing.id,
    y_offset: placing.yOffset,
    x_offset: placing.xOffset,
    height: placing.height,
    width: placing.width,
    tiled: placing.tiled,
    locked: placing.locked,
    store_id: placing.storeId,
    zindex: placing.zIndex,
    angle: placing.angle,
    _destroy: placing.destroy,
    clonable: placing.clonable,
    opacity: placing.opacity,
    count: placing.count,
    wall_id: placing.wallId,
    group_id: placing.groupId,
    group_width: placing.groupWidth,
    group_height: placing.groupHeight,
    group_z_index: placing.groupZIndex,
    parent_group_id: placing.parentGroupId,
    plane_config: placing.planeConfig
  };
  return jsonObj;
};

// Since visualize placings are not used in backend, I am not finding the exact map for deleted placings and
// Visaulize placings. In designer we will need single visualize placing data of particlur sticker to get the
// plane details.

export const isPlacingMappedPlacing = (placing1, placing2) =>
  placing1.parentGroupId == placing2.groupId &&
  placing1.placeableId == placing2.placeableId;
